import styled from 'styled-components/macro'
import { Icon } from './image'

export const SeasonSection = styled.section`
  display: block;
  width: 100%;
  & + & {
    margin-top: ${props => props.theme.margin};
  }
  cursor: pointer;
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.gray[3]};
  }
`

export const StarHeaderBottom = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const StarIcon = styled(Icon)`
  width: ${props => props.big ? "32px" : "12px"};
  height: ${props => props.big ? "32px" : "12px"};
  margin: ${props => props.big ? "0" : "0 5px"};
  filter: ${props => props.faded ? "brightness(0.7) invert(1)" : ""};
  background: ${props => props.big ? `url(${props.src})` : 'none'} no-repeat;
`

export const Season = styled.label`
  font-size: ${props => props.theme.fontSize.header};
  margin-right: auto;
`

export const Header = styled.div`
  width: 100%;
  position: sticky;
  top: ${props => props.theme.header.height};
  background-color: #fffe;
  font-size: ${props => props.theme.fontSize.text};
  font-weight: bold;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.gray[2]};
  margin-bottom: 4px;
  padding: ${props => props.theme.padding} 0;
  z-index: 2;
`

export const Body = styled.div`
  font-size: ${props => props.theme.fontSize.text};
  /* padding: ${props => props.theme.padding} 0; */
  display: flex;
  justify-content: space-between;
`

export const List = styled.div`
  /* display: ${props => props.show ? "block" : "none"}; */
`

export const Transaction = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.gray[3]};
`

export const TextContainer = styled.div`
  width: auto;
  height: 60px;
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export default styled.div`
  border-radius: ${props => props.theme.borderRadius};
  margin-bottom: ${props => props.theme.margin};
  background-color: white;
  width: 100%;
  padding: 0 ${props => props.theme.padding};
`